<script setup lang="ts">
import Toaster from "@/components/ui/toast/Toaster.vue";
import { RouterView } from "vue-router";
</script>

<template>
  <Toaster />
  <RouterView />
</template>
